<template>
    <span class="ml-1">
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-avatar 
                    class="plus" 
                    color="primary" 
                    :size="size" 
                    v-on="on"
                    @click="doAction(data)">
                    <span :class="textClass"><v-icon color="white">mdi-plus</v-icon></span>
                </v-avatar>
            </template>
            <span>{{ tooltip }}</span>
        </v-tooltip>
    </span>
</template>

<script>
    export default{ 
        props: {
            data: {
                type: String,
                required: true,               
            },
            tooltip: {
                type: String,
                required: false,  
                default: "Add",             
            },          
            size: {
                type: Number,
                required: false,
                default: 30,
            },
        },
        computed: {
            textClass() {
                if (this.size <= 25) {
                    return "white--text text-body-2 font-weight-bold";
                }
                return "white--text text-h6";
            },
        },
        data() {
            return {
            }
        },  
        methods: {
            doAction(data) {
                this.$emit("actionClick", data);
            }
        },
    }

</script>

<style scoped>
    .plus {
        cursor: pointer;
    }
</style>